var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowSmall = function SvgArrowSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 4.368h6.3c.686 0 1.596.014 2.198.042v-.014c-.294-.238-.7-.616-1.078-.994L4.102 0h1.442l4.886 4.9-4.886 4.9H4.102L7.42 6.398c.378-.378.784-.756 1.078-.994V5.39c-.602.028-1.512.042-2.198.042H0z"
  })));
};
export default SvgArrowSmall;